"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TabsContextProvider = exports.useTabs = void 0;

var _react = require("react");
/* istanbul ignore next */


var defaultCtxValue = {
  activeId: '',
  register: function register(id, data) {},
  onKeyDown: function onKeyDown(e) {},
  activate: function activate(id) {}
};
var TabsContext = (0, _react.createContext)(defaultCtxValue);
var TabsContextProvider = TabsContext.Provider;
exports.TabsContextProvider = TabsContextProvider;

var useTabs = function useTabs() {
  return (0, _react.useContext)(TabsContext);
};

exports.useTabs = useTabs;